import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	Table,
	Row,
	FormGroup,
	Input,
	Label,
	Collapse,
	Col,
	Button
} from "reactstrap";
import { Link } from "react-router-dom";
import * as moment from "moment";
import { STATUS_LIST, DATE_FORMATS, PAGE_LIMIT, MESSAGES } from '../../configs/constant'

import { CATEGORY } from '../../configs/urls'
import { getApi, deleteApi } from '../../services/api'

import Loader from '../../components/Loader'
import Toaster from "../../components/Toaster";

import './styles.css'
import { FaEdit } from 'react-icons/fa'

const CategoryList = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [isRequesting, setIsRequestig] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false)
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT,
	})
	const [categories, setCategories] = useState([])

	useEffect(() => {
		fetchCategory(false, true);
	}, []);

	const fetchCategory = (isLoadMore, isInitialLoad) => {
		isInitialLoad ? setIsRequestig(true) : setIsLoading(true);

		const params = JSON.parse(JSON.stringify(filterParams))

		for (const key in params) {
			if ((!params[key] && params[key] != 0) || params[key] == -1) {
				delete params[key]
			}
		}

		getApi(CATEGORY, params)
			.then((res) => {
				const categoriesData = isLoadMore ? [...categories, ...res.data] : res.data || []
				setCategories(categoriesData)
				setCanShowLoadMore(categoriesData.length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				isInitialLoad ? setIsRequestig(false) : setIsLoading(false);
			})
	}

	const deleteCategory = (category_id) => {
		var proceed = window.confirm("Are you sure you want to delete Category?");
		if (proceed) {
			deleteApi(`${CATEGORY}/${category_id}`)
				.then((res) => {
					let list = categories
					list = list.filter(item => item.id != category_id)
					setCategories(list)
					Toaster.showSuccess(res.message || 'Category deleted successfully.')
				}, (err) => {
					Toaster.showError(err.message)
				})
		}
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const resetFilter = () => {
		setFilterParams({
			status: -1,
			name: '',
			page: 0,
			size: PAGE_LIMIT,
		});

		fetchCategory();
	}

	const loadMoreCategories = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)


		fetchCategory(true);
	}

	const searchCategory = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		fetchCategory();
	}

	const renderCategories = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="header-section">
							<div>
								<Button color="primary" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filter</Button>
							</div>
							<Link to="category/operations">
								<Button color="primary" className="text-right">Add New Category</Button>
							</Link>
						</CardHeader>

						<Collapse isOpen={isFilterOpen} className="border-top">
							<Card>
								<CardBody>
									<Row>
										<Col className="pr-1" md="4">
											<FormGroup>
												<label>Category</label>
												<Input
													type="text"
													name="name"
													placeholder="Category Name"
													value={filterParams.name || ""}
													onChange={handleChange}
												/>
											</FormGroup>
										</Col>

										<Col className="pr-1" md="4">
											<FormGroup>
												<Label for="status">Status</Label>
												<Input
													type="select"
													name="status"
													value={filterParams.status}
													onChange={handleChange}
												>
													{
														STATUS_LIST.map(status => (
															<option key={status.id} value={status.id}>{status.title}</option>
														))
													}
												</Input>
											</FormGroup>
										</Col>

										<Col className="pr-1" md="4">
											<div className="update ml-auto mt-3 mr-auto">
												<Button className="btn-round" onClick={() => searchCategory()} color="primary">
													Search
												</Button>
												<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
													Reset
												</Button>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Collapse>

						<hr />

						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th>Category Name</th>
										<th>Status</th>
										<th>Last Update</th>
										<th className="text-right">Actions</th>
									</tr>
								</thead>
								<tbody>
									{
										categories.map((category, idx) => (
											<tr key={idx}>
												<td>{category.id}</td>
												<td>{category.name || '--'}</td>
												<td>{category.status == 1 ? 'Enabled' : 'Disabled'}</td>
												<td>{category.updated_at ? moment(category.updated_at).format(DATE_FORMATS.DATE_TIME_FORMAT) : '--'}</td>
												<td className="text-right action-icons">
													<Link to={`category/operations/${category.id}`}>
														<FaEdit />
													</Link>
												</td>
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								categories.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore && 
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreCategories()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderCategories()
			}
		</>
	);
}

export default CategoryList;
